// localStorage-backed song library.
// One key holds the whole array as JSON — simple, portable, easy to export.

import type { Song } from './types';

const KEY = 'strudel-harness:songs:v1';
const ACTIVE_KEY = 'strudel-harness:active-id:v1';

export function loadAll(): Song[] | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as Song[]) : null;
  } catch {
    return null;
  }
}

export function saveAll(songs: Song[]): void {
  localStorage.setItem(KEY, JSON.stringify(songs));
}

export function seedIfEmpty(defaults: Song[]): Song[] {
  const existing = loadAll();
  if (existing && existing.length > 0) return existing;
  saveAll(defaults);
  return defaults.slice();
}

export function loadActiveId(): string | null {
  try {
    const raw = localStorage.getItem(ACTIVE_KEY);
    return raw && raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
}

export function saveActiveId(id: string | null): void {
  try {
    if (id === null) localStorage.removeItem(ACTIVE_KEY);
    else localStorage.setItem(ACTIVE_KEY, id);
  } catch {
    // Persistence is best-effort.
  }
}

